import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"margin-top":"10px","font-weight":"800"} }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { class: "dialog-footer" }

import Pagination from '@/components/Pagination.vue'
import SelectChannel from '../../components/SelectChannel.vue'
import { useRoute,useRouter } from 'vue-router'
import OutDialog from './store/OutDialog.vue'
import { getCurrentInstance, reactive, onMounted, ref,nextTick,watch,computed } from 'vue'
import { useStore } from '@/store'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'

    interface OutNumI {
        id:number,
        name?:string,
        num?:number,
        count:number
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'OutApply',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const route = useRoute() as any
    const admin_id = store.state.user.userInfo.id
    const group_id = store.state.user.userInfo.group_id.split(',')
    const router = useRouter()
    const filters = reactive({
            channel_no:'',                   // 渠道编号
            coupon_id:'',//总库券包id
            name:'',//劵名称
            status:'',//审核状态
            out_status:'',//出库状态
            out_batch:'',//出库批次
            add_start_date:'',//开始有效期
            add_end_date:'',//结束有效期
            out_start_date:'',//出库开始时间
            out_end_date:'',//出库结束时间
            type:'',    //劵类型
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogNumSingleVisible:false,//填写单个通过数量弹框
        dialogNumVisible: false,   // 填写通过数量弹框
        dialogRejectVisible: false,   // 驳回弹框
        dialogReasonVisible:false, // 查看原因弹框
        isNew:true, //是否显示添加按钮
        imgs:'',   // 图片
        srcList:[],//图片预览
        count:'',//填写单个出库数量
        note:'',   // 驳回原因
        // type:0,   // 1 单条通过2 批量通过
        id:'',   
        ids:'',//批量通过
    })
    //列表对象
    const total = ref(0)
    const tableData = ref([])
    const outNumData = ref<OutNumI[]>([])
    //打开填写出库数量弹窗
    const numDialog = (ids,status)  => {
        if(!ids){
            return proxy.$message({ type: 'error', message: '请选择要处理的券包' })
        }else{
            proxy.$http.post('/coupon/offline_coupon/send_coupon_out_apply', {ids,checkIsOut:1,admin_id,status}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                outNumData.value = data
                state.dialogNumVisible = true

            })
        }
        
    }
    //结算汇总 
    const totalDiscount = computed(() => {
        // 使用 map 方法遍历 goods 数组，创建新的数组
        let updatedData = outNumData.value.map(item => {
            // 确保 num 和 clearing_price 是有效的数字，否则设为 0
            const count = parseFloat(item.count).toFixed(2) || 0;
            const clearingPrice = parseFloat(item.clearing_price).toFixed(2) || 0;

            // 创建新对象并更名字段
            return {
            ...item,
            total_price: count * clearingPrice,
            };
        });
        // 过滤掉 total_price 不是有效数字的项
        updatedData = updatedData.filter(item => !isNaN(item.total_price) && isFinite(item.total_price));

        // 计算总和
        return updatedData.reduce((total, item) => total + item.total_price, 0);
    });
    //出库数量弹窗关闭
    const numDialogClose = () => {
        state.dialogNumVisible = false
        outNumData.value = []
    }
    //打开单独出库数量弹窗
    const numDialogSingle = (row) => {
        state.id = row.id
        //@ts-ignore
        state.count = row.num-row.out_num
        state.dialogNumSingleVisible = true
    }
    //关闭单独出库数量弹窗
    const NumSingleDialogClose =()=>{
        outNumData.value = []
        state.count =''
        state.id = ''
        state.dialogNumSingleVisible = false
    }
    //打开驳回弹窗
    const rejectDialog = (row) => {
        state.id = row.id
        state.note = row.note
        state.dialogRejectVisible = true
    }
    //驳回弹窗关闭
    const rejectDialogClose = () => {
        state.id = ''
        state.note = ''
        state.dialogRejectVisible = false
    }
    //审核过的不可选中
    const selectable = (row) => {
        //驳回和全部出库的不可选
        if(row.status == 2 || row.out_status== 2){
            return false
        }else {
            return true
        }
    }
     // 选中监听
    const onSelectionChange = (val) => {
        state.ids = val.filter(item => item.out_status != 2 &&item.status !=2).map(item => item.id).join(',')
    }
    const toStatus = (ids,status) => {
        if(status==2 && !state.note){
            return proxy.$message({ type: 'error', message: '请输入驳回原因' })
        }
        if(state.count){
            //@ts-ignore
            outNumData.value.push({id:state.id,count:state.count})
        }
        proxy.$confirm(`是否确认${status==1 ? '通过':'驳回'}`, '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/coupon/offline_coupon/send_coupon_out_apply', {ids,status,admin_id,note:state.note,out_nums:outNumData.value}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: msg })
                //如果是通过则进入渠道出库页面
                const { channel_no, redis_batch,channel_name } = data
                const url = `/coupon-iso/out-preview?redis_batch=${redis_batch}&channel_no=${channel_no}&channel_name=${channel_name}`
                if(data.channel_no){
                    router.push(url)
                }
                rejectDialogClose()
                getList()
            })
        }).catch(() => {
            console.log('取消')
        })
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/coupon/offline_coupon/get_coupon_out_apply', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
            //@ts-ignore
            state.srcList = ['https://img.dangaoss.com/public/p/72/0/1176489_l.jpg']

        })
    }
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }
    const toReason = (note) => {
        state.note = note
        state.dialogReasonVisible = true
    }
    // 打开操作弹框
    const openActionDialog = ({type, outType = 1, coupon_id = '', coupon_name = '', union_ids = [], coupon_status = ''}) => {
        nextTick(() => {
            const actions = ['packageDialog', 'inDialog', 'outDialog']
            proxy.$refs[actions[type]].openDialog({type: outType, coupon_id, coupon_name, union_ids, coupon_status})
        })
    }
    const onExport = () => {
        window.open(`${Keys.baseUrl}/coupon/offline_coupon/get_coupon_out_apply?${joinParams({ ...filters, user_id: store.state.user.userInfo.id, is_export: 1 })}`)
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    watch(() => route.query.t, (newVal, oldVal) => {
        if (newVal === 3) {
            getList()
        }
    })
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.coupon_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.coupon_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券包id",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.status) = $event)),
        class: "filter-item",
        placeholder: "请选择审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待审核",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "通过",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.out_status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.out_status) = $event)),
        class: "filter-item",
        placeholder: "请选择出库状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待出库",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "部分出库",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "全部出库",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.type) = $event)),
        class: "filter-item",
        placeholder: "请选择类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "采购",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "自制",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.out_batch,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.out_batch) = $event)),
        modelModifiers: { trim: true },
        placeholder: "出库批次",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_start_date,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.add_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "申请开始时间",
        style: {"width":"150px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_end_date,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.add_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "申请结束时间",
        style: {"width":"150px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.out_start_date,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.out_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库开始时间",
        style: {"width":"150px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.out_end_date,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.out_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库结束时间",
        style: {"width":"150px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      (_unref(group_id).includes('1') || _unref(group_id).includes('3') || _unref(group_id).includes('45') || _unref(group_id).includes('75') || _unref(group_id).includes('20') || _unref(group_id).includes('77'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (openActionDialog({type: 2, outType: 3})))
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("渠道出库申请")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      ref: "multipleTableRef",
      data: tableData.value,
      stripe: "",
      border: "",
      onSelectionChange: onSelectionChange,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        (_unref(group_id).includes('5') || _unref(group_id).includes('1'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              selectable: selectable,
              "reserve-selection": true,
              title: "审核过的商品不可再次审核",
              width: "55"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_id",
          label: "券包id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "券包名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type_text",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "num",
          label: "申请数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_num",
          label: "出库数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "渠道结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price_all",
          label: "结算总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "申请时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_text",
          label: "审核状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_status_text",
          label: "出库状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_time",
          label: "出库时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_batch",
          label: "出库批次"
        }),
        _createVNode(_component_el_table_column, {
          prop: "valid_from",
          label: "有效期开始时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "valid_to",
          label: "有效期结束时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "admin_name",
          label: "申请人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "pay_type_text",
          label: "扣除预付款方式"
        }),
        _createVNode(_component_el_table_column, {
          prop: "imgs",
          label: "回单图片"
        }, {
          default: _withCtx((scope) => [
            (scope.row.imgs)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: {"width":"50px","height":"40px"},
                  src: scope.row.imgs,
                  "zoom-rate": 1.2,
                  "preview-src-list": state.srcList,
                  fit: "cover",
                  onClick: ($event: any) => (state.srcList = [scope.row.imgs]),
                  "z-index": 1000,
                  "preview-teleported": true
                }, null, 8, ["src", "preview-src-list", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "备注原因"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              (scope.row.out_status!=2 && _unref(group_id).includes('5') || scope.row.out_status!=2 && _unref(group_id).includes('1'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (numDialogSingle(scope.row))
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode(" 处理 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.status==0 && _unref(group_id).includes('5') || scope.row.status==0 && _unref(group_id).includes('1'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (rejectDialog(scope.row))
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode(" 驳回 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.note)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    style: {"margin-top":"10px"},
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toReason(scope.row.note))
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode(" 查看原因 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    (_unref(group_id).includes('5') || _unref(group_id).includes('1'))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (numDialog(state.ids,1)))
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [
            _createTextVNode(" 批量处理 ")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(OutDialog, {
      ref: "outDialog",
      onReloadList: getList
    }, null, 512),
    _createVNode(_component_el_dialog, {
      title: "原因",
      modelValue: state.dialogReasonVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state.dialogReasonVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, _toDisplayString(state.note), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "审核通过",
      modelValue: state.dialogNumSingleVisible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((state.dialogNumSingleVisible) = $event)),
      "before-close": NumSingleDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: NumSingleDialogClose }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (toStatus(state.id,1)))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { ref: "addRemarkForm" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "数量:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: state.count,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.count) = $event)),
                  modelModifiers: { trim: true },
                  min: "1"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量处理",
      modelValue: state.dialogNumVisible,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((state.dialogNumVisible) = $event)),
      "before-close": numDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, { onClick: numDialogClose }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (toStatus(state.ids,1)))
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: outNumData.value,
          stripe: "",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "index" }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "券包名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "num",
              label: "申请数量"
            }),
            _createVNode(_component_el_table_column, {
              prop: "clearing_price",
              label: "渠道结算价"
            }),
            _createVNode(_component_el_table_column, {
              width: "200px",
              prop: "count",
              label: "通过数量"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  type: "number",
                  placeholder: "请输入通过数量",
                  modelValue: scope.row.count,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.count) = $event),
                  modelModifiers: { trim: true },
                  max: scope.row.num,
                  min: "1"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "总结算金额" }, {
              default: _withCtx((scope) => [
                (scope.row.count !== null || scope.row.clearing_price !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((scope.row.count*scope.row.clearing_price).toFixed(2)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_7, "结算汇总：" + _toDisplayString(totalDiscount.value.toFixed(2)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      modelValue: state.dialogRejectVisible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((state.dialogRejectVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, { onClick: rejectDialogClose }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (toStatus(state.id,2)))
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { ref: "addRemarkForm" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "驳回原因:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: state.note,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.note) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})